import { z } from 'zod';
//TODO logged_in_user id not considered here
export const SelectionsSchema = z.array(
  z
    .object({
      option: z.object({
        id: z.string().or(z.number()),
      }),
      start_time: z.string(),
      end_time: z.string(),
      start_date: z.string().optional(),
      end_date: z.string().optional(),
    })
    .or(
      z.object({
        extra: z.object({ id: z.number() }),
      })
    )
    .and(
      z.object({
        guest_details: z
          .array(
            z.object({
              first_name: z.string().min(2),
              gender: z.string().optional(),
              last_name: z.string().min(2),
              title: z.string(),
            })
          )
          .or(
            z.object({
              first_name: z.string().min(2),
              gender: z.string().optional(),
              last_name: z.string().min(2),
              title: z.string(),
            })
          ),
      })
    )
);
export const SelectionGroupSchema = z.object({
  configuration_group: z
    .object({
      id: z.number().or(z.string()),
    })
    .optional(),
  is_extras: z.boolean().optional(),
  selections: SelectionsSchema,
});

export const SpaPackageBasketItemSchema = z.object({
  type: z.string(),
  spa_package: z.object({
    id: z.string().or(z.number()),
  }),
  check_in: z.string(),
  check_out: z.string(),
  guest_details: z.array(
    z.object({
      title: z.string(),
      first_name: z.string(),
      last_name: z.string(),
      gender: z.string(),
    })
  ),
  dynamic_package: z.string(),
  note: z.string().optional(),
  selection_groups: z.array(SelectionGroupSchema),
});

export type SpaPackageBasketItem = z.infer<typeof SpaPackageBasketItemSchema>;
export type SelectionGroup = z.infer<typeof SelectionGroupSchema>;
export type Selections = z.infer<typeof SelectionsSchema>;
